/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DashboardReportRunsDownloadCsvRetrieveParams,
  PatchedReportScheduleRequest,
  PatchedSavedReportRequest,
  ReportDetailRequestRequest,
  ReportDetailResponse,
  ReportFieldValuesRequestRequest,
  ReportFieldValuesResponse,
  ReportFieldsResponse,
  ReportRun,
  ReportRunPage,
  ReportRunRequestRequest,
  ReportSchedule,
  ReportScheduleRequest,
  ReportSummaryRequestRequest,
  ReportSummaryResponse,
  SavedReport,
  SavedReportRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getDashboardReportSchedulesListUrl = () => {




  return `/api/dashboard/report-schedules/`
}

/**
 * The requesting manager's scheduled report deliveries at the location in the header.
 */
export const dashboardReportSchedulesList = async ( options?: Parameters<typeof customFetch>[1]): Promise<ReportSchedule[]> => {

  return customFetch<ReportSchedule[]>(getDashboardReportSchedulesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDashboardReportSchedulesListQueryKey = () => {
    return [
    `/api/dashboard/report-schedules/`
    ] as const;
    }


export const getDashboardReportSchedulesListQueryOptions = <TData = Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDashboardReportSchedulesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardReportSchedulesList>>> = ({ signal }) => dashboardReportSchedulesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DashboardReportSchedulesListQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardReportSchedulesList>>>
export type DashboardReportSchedulesListQueryError = void


export function useDashboardReportSchedulesList<TData = Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportSchedulesList>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportSchedulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportSchedulesList<TData = Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportSchedulesList>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportSchedulesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportSchedulesList<TData = Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDashboardReportSchedulesList<TData = Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardReportSchedulesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDashboardReportSchedulesCreateUrl = () => {




  return `/api/dashboard/report-schedules/`
}

/**
 * The requesting manager's scheduled report deliveries at the location in the header.
 */
export const dashboardReportSchedulesCreate = async (reportScheduleRequest: ReportScheduleRequest, options?: Parameters<typeof customFetch>[1]): Promise<ReportSchedule> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ReportSchedule>(getDashboardReportSchedulesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reportScheduleRequest)
  }
);}





export const getDashboardReportSchedulesCreateMutationKey = () => ['dashboardReportSchedulesCreate'] as const;

export const getDashboardReportSchedulesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesCreate>>, TError,DashboardReportSchedulesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesCreate>>, TError,DashboardReportSchedulesCreateMutationVariables, TContext> => {

const mutationKey = getDashboardReportSchedulesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardReportSchedulesCreate>>, DashboardReportSchedulesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  dashboardReportSchedulesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardReportSchedulesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardReportSchedulesCreate>>>
    export type DashboardReportSchedulesCreateMutationBody = ReportScheduleRequest
    export type DashboardReportSchedulesCreateMutationError = void
    export type DashboardReportSchedulesCreateMutationVariables = {data: ReportScheduleRequest}

    export const useDashboardReportSchedulesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesCreate>>, TError,DashboardReportSchedulesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardReportSchedulesCreate>>,
        TError,
        DashboardReportSchedulesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardReportSchedulesCreateMutationOptions(options), queryClient);
    }
    export const getDashboardReportSchedulesRetrieveUrl = (id: number,) => {




  return `/api/dashboard/report-schedules/${id}/`
}

/**
 * The requesting manager's scheduled report deliveries at the location in the header.
 */
export const dashboardReportSchedulesRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ReportSchedule> => {

  return customFetch<ReportSchedule>(getDashboardReportSchedulesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDashboardReportSchedulesRetrieveQueryKey = (id: number,) => {
    return [
    `/api/dashboard/report-schedules/${id}/`
    ] as const;
    }


export const getDashboardReportSchedulesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDashboardReportSchedulesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>> = ({ signal }) => dashboardReportSchedulesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DashboardReportSchedulesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>>
export type DashboardReportSchedulesRetrieveQueryError = void


export function useDashboardReportSchedulesRetrieve<TData = Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportSchedulesRetrieve<TData = Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportSchedulesRetrieve<TData = Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDashboardReportSchedulesRetrieve<TData = Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportSchedulesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardReportSchedulesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDashboardReportSchedulesUpdateUrl = (id: number,) => {




  return `/api/dashboard/report-schedules/${id}/`
}

/**
 * The requesting manager's scheduled report deliveries at the location in the header.
 */
export const dashboardReportSchedulesUpdate = async (id: number,
    reportScheduleRequest: ReportScheduleRequest, options?: Parameters<typeof customFetch>[1]): Promise<ReportSchedule> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ReportSchedule>(getDashboardReportSchedulesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reportScheduleRequest)
  }
);}





export const getDashboardReportSchedulesUpdateMutationKey = () => ['dashboardReportSchedulesUpdate'] as const;

export const getDashboardReportSchedulesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesUpdate>>, TError,DashboardReportSchedulesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesUpdate>>, TError,DashboardReportSchedulesUpdateMutationVariables, TContext> => {

const mutationKey = getDashboardReportSchedulesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardReportSchedulesUpdate>>, DashboardReportSchedulesUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  dashboardReportSchedulesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardReportSchedulesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardReportSchedulesUpdate>>>
    export type DashboardReportSchedulesUpdateMutationBody = ReportScheduleRequest
    export type DashboardReportSchedulesUpdateMutationError = void
    export type DashboardReportSchedulesUpdateMutationVariables = {id: number;data: ReportScheduleRequest}

    export const useDashboardReportSchedulesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesUpdate>>, TError,DashboardReportSchedulesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardReportSchedulesUpdate>>,
        TError,
        DashboardReportSchedulesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardReportSchedulesUpdateMutationOptions(options), queryClient);
    }
    export const getDashboardReportSchedulesPartialUpdateUrl = (id: number,) => {




  return `/api/dashboard/report-schedules/${id}/`
}

/**
 * The requesting manager's scheduled report deliveries at the location in the header.
 */
export const dashboardReportSchedulesPartialUpdate = async (id: number,
    patchedReportScheduleRequest?: PatchedReportScheduleRequest, options?: Parameters<typeof customFetch>[1]): Promise<ReportSchedule> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ReportSchedule>(getDashboardReportSchedulesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedReportScheduleRequest)
  }
);}





export const getDashboardReportSchedulesPartialUpdateMutationKey = () => ['dashboardReportSchedulesPartialUpdate'] as const;

export const getDashboardReportSchedulesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesPartialUpdate>>, TError,DashboardReportSchedulesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesPartialUpdate>>, TError,DashboardReportSchedulesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getDashboardReportSchedulesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardReportSchedulesPartialUpdate>>, DashboardReportSchedulesPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  dashboardReportSchedulesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardReportSchedulesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardReportSchedulesPartialUpdate>>>
    export type DashboardReportSchedulesPartialUpdateMutationBody = PatchedReportScheduleRequest | undefined
    export type DashboardReportSchedulesPartialUpdateMutationError = void
    export type DashboardReportSchedulesPartialUpdateMutationVariables = {id: number;data?: PatchedReportScheduleRequest}

    export const useDashboardReportSchedulesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesPartialUpdate>>, TError,DashboardReportSchedulesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardReportSchedulesPartialUpdate>>,
        TError,
        DashboardReportSchedulesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardReportSchedulesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getDashboardReportSchedulesDestroyUrl = (id: number,) => {




  return `/api/dashboard/report-schedules/${id}/`
}

/**
 * The requesting manager's scheduled report deliveries at the location in the header.
 */
export const dashboardReportSchedulesDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDashboardReportSchedulesDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDashboardReportSchedulesDestroyMutationKey = () => ['dashboardReportSchedulesDestroy'] as const;

export const getDashboardReportSchedulesDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesDestroy>>, TError,DashboardReportSchedulesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesDestroy>>, TError,DashboardReportSchedulesDestroyMutationVariables, TContext> => {

const mutationKey = getDashboardReportSchedulesDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardReportSchedulesDestroy>>, DashboardReportSchedulesDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  dashboardReportSchedulesDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardReportSchedulesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardReportSchedulesDestroy>>>

    export type DashboardReportSchedulesDestroyMutationError = void
    export type DashboardReportSchedulesDestroyMutationVariables = {id: number}

    export const useDashboardReportSchedulesDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSchedulesDestroy>>, TError,DashboardReportSchedulesDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardReportSchedulesDestroy>>,
        TError,
        DashboardReportSchedulesDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardReportSchedulesDestroyMutationOptions(options), queryClient);
    }
    export const getDashboardReportDetailCreateUrl = () => {




  return `/api/dashboard/report/detail/`
}

/**
 * One row per shift with the requested columns, filtered, sorted and paginated.
 */
export const dashboardReportDetailCreate = async (reportDetailRequestRequest: ReportDetailRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<ReportDetailResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ReportDetailResponse>(getDashboardReportDetailCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reportDetailRequestRequest)
  }
);}





export const getDashboardReportDetailCreateMutationKey = () => ['dashboardReportDetailCreate'] as const;

export const getDashboardReportDetailCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportDetailCreate>>, TError,DashboardReportDetailCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardReportDetailCreate>>, TError,DashboardReportDetailCreateMutationVariables, TContext> => {

const mutationKey = getDashboardReportDetailCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardReportDetailCreate>>, DashboardReportDetailCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  dashboardReportDetailCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardReportDetailCreateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardReportDetailCreate>>>
    export type DashboardReportDetailCreateMutationBody = ReportDetailRequestRequest
    export type DashboardReportDetailCreateMutationError = void
    export type DashboardReportDetailCreateMutationVariables = {data: ReportDetailRequestRequest}

    export const useDashboardReportDetailCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportDetailCreate>>, TError,DashboardReportDetailCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardReportDetailCreate>>,
        TError,
        DashboardReportDetailCreateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardReportDetailCreateMutationOptions(options), queryClient);
    }
    export const getDashboardReportFieldValuesCreateUrl = () => {




  return `/api/dashboard/report/field-values/`
}

/**
 * Distinct values of a text field with their shift counts, over the same rows the report reads.
 */
export const dashboardReportFieldValuesCreate = async (reportFieldValuesRequestRequest: ReportFieldValuesRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<ReportFieldValuesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ReportFieldValuesResponse>(getDashboardReportFieldValuesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reportFieldValuesRequestRequest)
  }
);}





export const getDashboardReportFieldValuesCreateMutationKey = () => ['dashboardReportFieldValuesCreate'] as const;

export const getDashboardReportFieldValuesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportFieldValuesCreate>>, TError,DashboardReportFieldValuesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardReportFieldValuesCreate>>, TError,DashboardReportFieldValuesCreateMutationVariables, TContext> => {

const mutationKey = getDashboardReportFieldValuesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardReportFieldValuesCreate>>, DashboardReportFieldValuesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  dashboardReportFieldValuesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardReportFieldValuesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardReportFieldValuesCreate>>>
    export type DashboardReportFieldValuesCreateMutationBody = ReportFieldValuesRequestRequest
    export type DashboardReportFieldValuesCreateMutationError = void
    export type DashboardReportFieldValuesCreateMutationVariables = {data: ReportFieldValuesRequestRequest}

    export const useDashboardReportFieldValuesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportFieldValuesCreate>>, TError,DashboardReportFieldValuesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardReportFieldValuesCreate>>,
        TError,
        DashboardReportFieldValuesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardReportFieldValuesCreateMutationOptions(options), queryClient);
    }
    export const getDashboardReportFieldsRetrieveUrl = () => {




  return `/api/dashboard/report/fields/`
}

/**
 * Report fields the location can pick from; processor-specific fields only when the location uses them.
 */
export const dashboardReportFieldsRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<ReportFieldsResponse> => {

  return customFetch<ReportFieldsResponse>(getDashboardReportFieldsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDashboardReportFieldsRetrieveQueryKey = () => {
    return [
    `/api/dashboard/report/fields/`
    ] as const;
    }


export const getDashboardReportFieldsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDashboardReportFieldsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>> = ({ signal }) => dashboardReportFieldsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DashboardReportFieldsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>>
export type DashboardReportFieldsRetrieveQueryError = void


export function useDashboardReportFieldsRetrieve<TData = Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportFieldsRetrieve<TData = Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportFieldsRetrieve<TData = Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDashboardReportFieldsRetrieve<TData = Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportFieldsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardReportFieldsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDashboardReportRunsListUrl = () => {




  return `/api/dashboard/report/runs/`
}

/**
 * The requesting manager's report runs at the location, newest first; POST generates a new one.
 *
 * A report under ``REPORT_RUN_INLINE_MAX_ROWS`` rows is generated at once (200, ``result`` included). A larger
 * detail report is queued for a worker (202): poll the run until its status is "done" or "failed".
 */
export const dashboardReportRunsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<ReportRunPage> => {

  return customFetch<ReportRunPage>(getDashboardReportRunsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDashboardReportRunsListQueryKey = () => {
    return [
    `/api/dashboard/report/runs/`
    ] as const;
    }


export const getDashboardReportRunsListQueryOptions = <TData = Awaited<ReturnType<typeof dashboardReportRunsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDashboardReportRunsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardReportRunsList>>> = ({ signal }) => dashboardReportRunsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DashboardReportRunsListQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardReportRunsList>>>
export type DashboardReportRunsListQueryError = void


export function useDashboardReportRunsList<TData = Awaited<ReturnType<typeof dashboardReportRunsList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportRunsList>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportRunsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportRunsList<TData = Awaited<ReturnType<typeof dashboardReportRunsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportRunsList>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportRunsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportRunsList<TData = Awaited<ReturnType<typeof dashboardReportRunsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDashboardReportRunsList<TData = Awaited<ReturnType<typeof dashboardReportRunsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardReportRunsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDashboardReportRunsCreateUrl = () => {




  return `/api/dashboard/report/runs/`
}

/**
 * The requesting manager's report runs at the location, newest first; POST generates a new one.
 *
 * A report under ``REPORT_RUN_INLINE_MAX_ROWS`` rows is generated at once (200, ``result`` included). A larger
 * detail report is queued for a worker (202): poll the run until its status is "done" or "failed".
 */
export const dashboardReportRunsCreate = async (reportRunRequestRequest: ReportRunRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<ReportRun> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ReportRun>(getDashboardReportRunsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reportRunRequestRequest)
  }
);}





export const getDashboardReportRunsCreateMutationKey = () => ['dashboardReportRunsCreate'] as const;

export const getDashboardReportRunsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportRunsCreate>>, TError,DashboardReportRunsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardReportRunsCreate>>, TError,DashboardReportRunsCreateMutationVariables, TContext> => {

const mutationKey = getDashboardReportRunsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardReportRunsCreate>>, DashboardReportRunsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  dashboardReportRunsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardReportRunsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardReportRunsCreate>>>
    export type DashboardReportRunsCreateMutationBody = ReportRunRequestRequest
    export type DashboardReportRunsCreateMutationError = void
    export type DashboardReportRunsCreateMutationVariables = {data: ReportRunRequestRequest}

    export const useDashboardReportRunsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportRunsCreate>>, TError,DashboardReportRunsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardReportRunsCreate>>,
        TError,
        DashboardReportRunsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardReportRunsCreateMutationOptions(options), queryClient);
    }
    export const getDashboardReportRunsRetrieveUrl = (runId: string,) => {




  return `/api/dashboard/report/runs/${runId}/`
}

/**
 * A report run, with its stored result once it is done. Never re-queries the report.
 */
export const dashboardReportRunsRetrieve = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<ReportRun> => {

  return customFetch<ReportRun>(getDashboardReportRunsRetrieveUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDashboardReportRunsRetrieveQueryKey = (runId: string,) => {
    return [
    `/api/dashboard/report/runs/${runId}/`
    ] as const;
    }


export const getDashboardReportRunsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError = void>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDashboardReportRunsRetrieveQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>> = ({ signal }) => dashboardReportRunsRetrieve(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DashboardReportRunsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>>
export type DashboardReportRunsRetrieveQueryError = void


export function useDashboardReportRunsRetrieve<TData = Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError = void>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportRunsRetrieve<TData = Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError = void>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportRunsRetrieve<TData = Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError = void>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDashboardReportRunsRetrieve<TData = Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError = void>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardReportRunsRetrieveQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDashboardReportRunsDownloadCsvRetrieveUrl = (runId: string,
    params?: DashboardReportRunsDownloadCsvRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/report/runs/${runId}/download.csv?${stringifiedParams}` : `/api/dashboard/report/runs/${runId}/download.csv`
}

/**
 * The run's stored result as a CSV attachment, served only to its owner.
 */
export const dashboardReportRunsDownloadCsvRetrieve = async (runId: string,
    params?: DashboardReportRunsDownloadCsvRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getDashboardReportRunsDownloadCsvRetrieveUrl(runId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDashboardReportRunsDownloadCsvRetrieveQueryKey = (runId: string,
    params?: DashboardReportRunsDownloadCsvRetrieveParams,) => {
    return [
    `/api/dashboard/report/runs/${runId}/download.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getDashboardReportRunsDownloadCsvRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError = void>(runId: string,
    params?: DashboardReportRunsDownloadCsvRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDashboardReportRunsDownloadCsvRetrieveQueryKey(runId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>> = ({ signal }) => dashboardReportRunsDownloadCsvRetrieve(runId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DashboardReportRunsDownloadCsvRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>>
export type DashboardReportRunsDownloadCsvRetrieveQueryError = void


export function useDashboardReportRunsDownloadCsvRetrieve<TData = Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError = void>(
 runId: string,
    params: undefined |  DashboardReportRunsDownloadCsvRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportRunsDownloadCsvRetrieve<TData = Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError = void>(
 runId: string,
    params?: DashboardReportRunsDownloadCsvRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardReportRunsDownloadCsvRetrieve<TData = Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError = void>(
 runId: string,
    params?: DashboardReportRunsDownloadCsvRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDashboardReportRunsDownloadCsvRetrieve<TData = Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError = void>(
 runId: string,
    params?: DashboardReportRunsDownloadCsvRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardReportRunsDownloadCsvRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardReportRunsDownloadCsvRetrieveQueryOptions(runId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDashboardReportSummaryCreateUrl = () => {




  return `/api/dashboard/report/summary/`
}

/**
 * Server-side pivot of shifts: grouped rows, optional columns, aggregates, subtotals and a grand total.
 */
export const dashboardReportSummaryCreate = async (reportSummaryRequestRequest: ReportSummaryRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<ReportSummaryResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ReportSummaryResponse>(getDashboardReportSummaryCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reportSummaryRequestRequest)
  }
);}





export const getDashboardReportSummaryCreateMutationKey = () => ['dashboardReportSummaryCreate'] as const;

export const getDashboardReportSummaryCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSummaryCreate>>, TError,DashboardReportSummaryCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSummaryCreate>>, TError,DashboardReportSummaryCreateMutationVariables, TContext> => {

const mutationKey = getDashboardReportSummaryCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardReportSummaryCreate>>, DashboardReportSummaryCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  dashboardReportSummaryCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardReportSummaryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardReportSummaryCreate>>>
    export type DashboardReportSummaryCreateMutationBody = ReportSummaryRequestRequest
    export type DashboardReportSummaryCreateMutationError = void
    export type DashboardReportSummaryCreateMutationVariables = {data: ReportSummaryRequestRequest}

    export const useDashboardReportSummaryCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardReportSummaryCreate>>, TError,DashboardReportSummaryCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardReportSummaryCreate>>,
        TError,
        DashboardReportSummaryCreateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardReportSummaryCreateMutationOptions(options), queryClient);
    }
    export const getDashboardSavedReportsListUrl = () => {




  return `/api/dashboard/saved-reports/`
}

/**
 * The requesting manager's saved report configurations at the location in the header.
 */
export const dashboardSavedReportsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<SavedReport[]> => {

  return customFetch<SavedReport[]>(getDashboardSavedReportsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDashboardSavedReportsListQueryKey = () => {
    return [
    `/api/dashboard/saved-reports/`
    ] as const;
    }


export const getDashboardSavedReportsListQueryOptions = <TData = Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDashboardSavedReportsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardSavedReportsList>>> = ({ signal }) => dashboardSavedReportsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DashboardSavedReportsListQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardSavedReportsList>>>
export type DashboardSavedReportsListQueryError = void


export function useDashboardSavedReportsList<TData = Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardSavedReportsList>>,
          TError,
          Awaited<ReturnType<typeof dashboardSavedReportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardSavedReportsList<TData = Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardSavedReportsList>>,
          TError,
          Awaited<ReturnType<typeof dashboardSavedReportsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardSavedReportsList<TData = Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDashboardSavedReportsList<TData = Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardSavedReportsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDashboardSavedReportsCreateUrl = () => {




  return `/api/dashboard/saved-reports/`
}

/**
 * The requesting manager's saved report configurations at the location in the header.
 */
export const dashboardSavedReportsCreate = async (savedReportRequest: SavedReportRequest, options?: Parameters<typeof customFetch>[1]): Promise<SavedReport> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SavedReport>(getDashboardSavedReportsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(savedReportRequest)
  }
);}





export const getDashboardSavedReportsCreateMutationKey = () => ['dashboardSavedReportsCreate'] as const;

export const getDashboardSavedReportsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsCreate>>, TError,DashboardSavedReportsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsCreate>>, TError,DashboardSavedReportsCreateMutationVariables, TContext> => {

const mutationKey = getDashboardSavedReportsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardSavedReportsCreate>>, DashboardSavedReportsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  dashboardSavedReportsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardSavedReportsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardSavedReportsCreate>>>
    export type DashboardSavedReportsCreateMutationBody = SavedReportRequest
    export type DashboardSavedReportsCreateMutationError = void
    export type DashboardSavedReportsCreateMutationVariables = {data: SavedReportRequest}

    export const useDashboardSavedReportsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsCreate>>, TError,DashboardSavedReportsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardSavedReportsCreate>>,
        TError,
        DashboardSavedReportsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardSavedReportsCreateMutationOptions(options), queryClient);
    }
    export const getDashboardSavedReportsRetrieveUrl = (id: number,) => {




  return `/api/dashboard/saved-reports/${id}/`
}

/**
 * The requesting manager's saved report configurations at the location in the header.
 */
export const dashboardSavedReportsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<SavedReport> => {

  return customFetch<SavedReport>(getDashboardSavedReportsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDashboardSavedReportsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/dashboard/saved-reports/${id}/`
    ] as const;
    }


export const getDashboardSavedReportsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDashboardSavedReportsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>> = ({ signal }) => dashboardSavedReportsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DashboardSavedReportsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>>
export type DashboardSavedReportsRetrieveQueryError = void


export function useDashboardSavedReportsRetrieve<TData = Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardSavedReportsRetrieve<TData = Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDashboardSavedReportsRetrieve<TData = Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDashboardSavedReportsRetrieve<TData = Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboardSavedReportsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardSavedReportsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDashboardSavedReportsUpdateUrl = (id: number,) => {




  return `/api/dashboard/saved-reports/${id}/`
}

/**
 * The requesting manager's saved report configurations at the location in the header.
 */
export const dashboardSavedReportsUpdate = async (id: number,
    savedReportRequest: SavedReportRequest, options?: Parameters<typeof customFetch>[1]): Promise<SavedReport> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SavedReport>(getDashboardSavedReportsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(savedReportRequest)
  }
);}





export const getDashboardSavedReportsUpdateMutationKey = () => ['dashboardSavedReportsUpdate'] as const;

export const getDashboardSavedReportsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsUpdate>>, TError,DashboardSavedReportsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsUpdate>>, TError,DashboardSavedReportsUpdateMutationVariables, TContext> => {

const mutationKey = getDashboardSavedReportsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardSavedReportsUpdate>>, DashboardSavedReportsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  dashboardSavedReportsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardSavedReportsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardSavedReportsUpdate>>>
    export type DashboardSavedReportsUpdateMutationBody = SavedReportRequest
    export type DashboardSavedReportsUpdateMutationError = void
    export type DashboardSavedReportsUpdateMutationVariables = {id: number;data: SavedReportRequest}

    export const useDashboardSavedReportsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsUpdate>>, TError,DashboardSavedReportsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardSavedReportsUpdate>>,
        TError,
        DashboardSavedReportsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardSavedReportsUpdateMutationOptions(options), queryClient);
    }
    export const getDashboardSavedReportsPartialUpdateUrl = (id: number,) => {




  return `/api/dashboard/saved-reports/${id}/`
}

/**
 * The requesting manager's saved report configurations at the location in the header.
 */
export const dashboardSavedReportsPartialUpdate = async (id: number,
    patchedSavedReportRequest?: PatchedSavedReportRequest, options?: Parameters<typeof customFetch>[1]): Promise<SavedReport> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SavedReport>(getDashboardSavedReportsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedSavedReportRequest)
  }
);}





export const getDashboardSavedReportsPartialUpdateMutationKey = () => ['dashboardSavedReportsPartialUpdate'] as const;

export const getDashboardSavedReportsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsPartialUpdate>>, TError,DashboardSavedReportsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsPartialUpdate>>, TError,DashboardSavedReportsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getDashboardSavedReportsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardSavedReportsPartialUpdate>>, DashboardSavedReportsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  dashboardSavedReportsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardSavedReportsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardSavedReportsPartialUpdate>>>
    export type DashboardSavedReportsPartialUpdateMutationBody = PatchedSavedReportRequest | undefined
    export type DashboardSavedReportsPartialUpdateMutationError = void
    export type DashboardSavedReportsPartialUpdateMutationVariables = {id: number;data?: PatchedSavedReportRequest}

    export const useDashboardSavedReportsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsPartialUpdate>>, TError,DashboardSavedReportsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardSavedReportsPartialUpdate>>,
        TError,
        DashboardSavedReportsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardSavedReportsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getDashboardSavedReportsDestroyUrl = (id: number,) => {




  return `/api/dashboard/saved-reports/${id}/`
}

/**
 * The requesting manager's saved report configurations at the location in the header.
 */
export const dashboardSavedReportsDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDashboardSavedReportsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDashboardSavedReportsDestroyMutationKey = () => ['dashboardSavedReportsDestroy'] as const;

export const getDashboardSavedReportsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsDestroy>>, TError,DashboardSavedReportsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsDestroy>>, TError,DashboardSavedReportsDestroyMutationVariables, TContext> => {

const mutationKey = getDashboardSavedReportsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardSavedReportsDestroy>>, DashboardSavedReportsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  dashboardSavedReportsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardSavedReportsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardSavedReportsDestroy>>>

    export type DashboardSavedReportsDestroyMutationError = void
    export type DashboardSavedReportsDestroyMutationVariables = {id: number}

    export const useDashboardSavedReportsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsDestroy>>, TError,DashboardSavedReportsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardSavedReportsDestroy>>,
        TError,
        DashboardSavedReportsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardSavedReportsDestroyMutationOptions(options), queryClient);
    }
    export const getDashboardSavedReportsSetDefaultCreateUrl = (id: number,) => {




  return `/api/dashboard/saved-reports/${id}/set-default/`
}

/**
 * Makes this report the owner's default at the location, clearing any previous default.
 */
export const dashboardSavedReportsSetDefaultCreate = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<SavedReport> => {

  return customFetch<SavedReport>(getDashboardSavedReportsSetDefaultCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDashboardSavedReportsSetDefaultCreateMutationKey = () => ['dashboardSavedReportsSetDefaultCreate'] as const;

export const getDashboardSavedReportsSetDefaultCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsSetDefaultCreate>>, TError,DashboardSavedReportsSetDefaultCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsSetDefaultCreate>>, TError,DashboardSavedReportsSetDefaultCreateMutationVariables, TContext> => {

const mutationKey = getDashboardSavedReportsSetDefaultCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardSavedReportsSetDefaultCreate>>, DashboardSavedReportsSetDefaultCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  dashboardSavedReportsSetDefaultCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardSavedReportsSetDefaultCreateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardSavedReportsSetDefaultCreate>>>

    export type DashboardSavedReportsSetDefaultCreateMutationError = void
    export type DashboardSavedReportsSetDefaultCreateMutationVariables = {id: number}

    export const useDashboardSavedReportsSetDefaultCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsSetDefaultCreate>>, TError,DashboardSavedReportsSetDefaultCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardSavedReportsSetDefaultCreate>>,
        TError,
        DashboardSavedReportsSetDefaultCreateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardSavedReportsSetDefaultCreateMutationOptions(options), queryClient);
    }
    export const getDashboardSavedReportsUnsetDefaultCreateUrl = (id: number,) => {




  return `/api/dashboard/saved-reports/${id}/unset-default/`
}

/**
 * The requesting manager's saved report configurations at the location in the header.
 */
export const dashboardSavedReportsUnsetDefaultCreate = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<SavedReport> => {

  return customFetch<SavedReport>(getDashboardSavedReportsUnsetDefaultCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDashboardSavedReportsUnsetDefaultCreateMutationKey = () => ['dashboardSavedReportsUnsetDefaultCreate'] as const;

export const getDashboardSavedReportsUnsetDefaultCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsUnsetDefaultCreate>>, TError,DashboardSavedReportsUnsetDefaultCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsUnsetDefaultCreate>>, TError,DashboardSavedReportsUnsetDefaultCreateMutationVariables, TContext> => {

const mutationKey = getDashboardSavedReportsUnsetDefaultCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dashboardSavedReportsUnsetDefaultCreate>>, DashboardSavedReportsUnsetDefaultCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  dashboardSavedReportsUnsetDefaultCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DashboardSavedReportsUnsetDefaultCreateMutationResult = NonNullable<Awaited<ReturnType<typeof dashboardSavedReportsUnsetDefaultCreate>>>

    export type DashboardSavedReportsUnsetDefaultCreateMutationError = void
    export type DashboardSavedReportsUnsetDefaultCreateMutationVariables = {id: number}

    export const useDashboardSavedReportsUnsetDefaultCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dashboardSavedReportsUnsetDefaultCreate>>, TError,DashboardSavedReportsUnsetDefaultCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dashboardSavedReportsUnsetDefaultCreate>>,
        TError,
        DashboardSavedReportsUnsetDefaultCreateMutationVariables,
        TContext
      > => {
      return useMutation(getDashboardSavedReportsUnsetDefaultCreateMutationOptions(options), queryClient);
    }
